export const CONTACT_CARD_EDIT_MODES = {
  NONE: "NONE",
  RELATIONSHIP: "RELATIONSHIP",
  CONTACT: "CONTACT",
  CREATE: "CREATE",
};

export const CONTACT_TYPES = {
  COMMUNITIES: "communities",
  HOMES: "homes",
  BUILDERS: "builders",
};

export const RESOURCE_LEVEL = {
  COMMUNITIES: "communities",
  HOMES: "homes",
  BUILDERS: "builders",
};
export const LEVEL_LABELS = {
  communities: "Community",
  homes: "Home",
  builders: "Builder",
};
export const CONTACT_STATUSES = {
  ACTIVE: "Active",
  INACTIVE: "Inactive",
  ARCHIVED: "Archived",
  INCOMPLETE: "Incomplete",
};

export const HOME_LEVEL_OPTIONS = [
  {
    label: "Community",
    value: "communities",
  },
  {
    label: "Home",
    value: "homes",
  },
];

export const PREFERRED_CONTACT_METHOD = {
  Email: "Email",
  Phone: "Phone",
};

export const PROPERTY_TYPE = {
  NEW_HOME_CONSTRUCTION: "NewHomeConstruction",
  SERVICE: "Service",
};

export const CONTACT_STATUSES_OPTIONS = [
  {
    label: "Active",
    value: "Active",
  },
  {
    label: "Inactive",
    value: "Inactive",
  },
];

export const PREFERRED_CONTACT_METHOD_OPTIONS = [
  {
    label: "Email",
    value: "Email",
  },
  {
    label: "Phone",
    value: "Phone",
  },
];

export const CONTACT_DISPLAY_TYPE = {
  [CONTACT_TYPES.COMMUNITIES]: "Community",
  [CONTACT_TYPES.HOMES]: "Home",
  [CONTACT_TYPES.BUILDERS]: "Builder",
};

export const PROPERTY_TYPE_OPTIONS = [
  {
    label: "New Home Construction",
    value: PROPERTY_TYPE.NEW_HOME_CONSTRUCTION,
  },
  {
    label: "Service",
    value: PROPERTY_TYPE.SERVICE,
  },
];
